// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w7_P","newExpiryDate":"styles_newExpiryDate__lAlZv","footer":"styles_footer__2hIwH"};